(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
  var pasek = document.currentScript.previousElementSibling.previousElementSibling;
  if (!pasek) { return; }
  var btn = pasek.querySelector('.okruszki-kopiuj');
  if (!btn) { return; }
  btn.addEventListener('click', function () {
    var kanon = document.querySelector('link[rel="canonical"]');
    var url = (kanon && kanon.href) || location.href;
    function udane() {
      btn.classList.add('okruszki-kopiuj--ok');
      btn.setAttribute('title', '' + __pewniaki_inline_cfg[0] + '');
      setTimeout(function () {
        btn.classList.remove('okruszki-kopiuj--ok');
        btn.setAttribute('title', '' + __pewniaki_inline_cfg[1] + '');
      }, 1500);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(udane, function () {});
    } else {
      var t = document.createElement('textarea');
      t.value = url; t.classList.add('kopiowanie-ukryte');
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); udane(); } catch (e) {}
      document.body.removeChild(t);
    }
  });
})();
})();
